import http from '@/api/http'

export default {
    getPublicDocuments(){
        return http({ url: '/public-documents', method: 'get'})
  }
}